/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssessmentExaminationApiModel { 
    id?: number | null;
    name: string;
    result?: string | null;
    examinationDate: string;
    examinationTypeId: number;
}

